import MagicData from './MagicData.js'

const sidePort = 42521

let ws = null
let magicDatas = null
let grandMagicDatas = null
let setVariableQueue = null
let setGrandVariableQueue = null
let connectMagicDataQueue = null
let connectGrandMagicDataQueue = null
let connectionLost = false

function connect() {

	if (window.location.hostname === 'remote.infra.antalzic.com') {
		let allowedRooms = (new URLSearchParams(window.location.search)).get('rooms') || ''
		ws = new WebSocket('wss://remotews.infra.antalzic.com/'+allowedRooms)
	}
	else ws = new WebSocket('ws://'+window.location.hostname+':'+sidePort+'/')

	magicDatas = {}
	grandMagicDatas = {}
	setVariableQueue = []
	setGrandVariableQueue = []
	connectMagicDataQueue = []
	connectGrandMagicDataQueue = []

	ws.onerror = function(error) {
		console.log('WebSocket error: '+error)
	}
	ws.onopen = function() {
		console.log('WebSocket open')
		if (connectionLost) window.location.reload()
	}
	ws.onclose = function() {
		console.log('WebSocket close')
		Com.connectedMagicData.setValue(false)
		connectionLost = true
		setTimeout(connect, 5000)
	}

	ws.onmessage = function(e) {
		let data = JSON.parse(e.data)
		if (!data) throw 'JSON.parse error of: '+e.data
		let newChildren = {}
		let newGrandChildren = {}
		for (let childName in data.children) {
			if (!Com.theData || !Com.theData.children[childName]) newChildren[childName] = true
			if (data.children[childName].children) {
				for (let grandChildName in data.children[childName].children) {
					if (!Com.theData
					|| !Com.theData.children[childName]
					|| !Com.theData.children[childName].children[grandChildName]) {
						if (!newGrandChildren[childName]) newGrandChildren[childName] = {}
						newGrandChildren[childName][grandChildName] = true
					}
				}
			}
		}
		if (!Com.theData) {
			Com.theData = data
			for (let args of connectMagicDataQueue) {
				connectMagicData(args[0], args[1], args[2], args[3])
			}
			for (let args of connectGrandMagicDataQueue) {
				connectGrandMagicData(args[0], args[1], args[2], args[3], args[4])
			}
			for (let args of setVariableQueue) {
				setVariable(args[0], args[1], args[2])
			}
			for (let args of setGrandVariableQueue) {
				setGrandVariable(args[0], args[1], args[2], args[3])
			}
			Com.connectedMagicData.setValue(true)
		}
		else applyModificationsRec(Com.theData, data)
		for (let name in data.variables) {
			if (magicDatas[''] && magicDatas[''][name]) magicDatas[''][name].setValue(data.variables[name])
		}
		for (let childName in data.children) {
			let child = data.children[childName]
			if (!child) {
				magicDatas[childName] = {}
				if (Com.childLeft) Com.childLeft(childName)
				continue
			}
			for (let name in child.variables) {
				if (magicDatas[childName] && magicDatas[childName][name]) magicDatas[childName][name].setValue(child.variables[name])
			}
			for (let grandChildName in child.children) {
				let grandChild = child.children[grandChildName]
				if (!grandChild) {
					if (!grandMagicDatas[childName]) grandMagicDatas[childName] = {}
					grandMagicDatas[childName][grandChildName] = {}
					if (Com.grandChildLeft) Com.grandChildLeft(childName, grandChildName)
					continue
				}
				for (let name in grandChild.variables) {
					if (grandMagicDatas[childName] && grandMagicDatas[childName][grandChildName] && grandMagicDatas[childName][grandChildName][name]) grandMagicDatas[childName][grandChildName][name].setValue(grandChild.variables[name])
				}
			}
		}
		for (let newChildName in newChildren) {
			if (Com.newChildArrived) Com.newChildArrived(newChildName)
		}
		for (let newChildName in newGrandChildren) {
			for (let newGrandChildName in newGrandChildren) {
				if (Com.newGrandChildArrived) Com.newGrandChildArrived(newChildName, newGrandChildName)
			}
		}
	}

}

function applyModificationsRec(server, modifs) {
	for (let key in modifs.variables) {
		if (modifs.variables[key] === null || modifs.variables[key] === '') delete server.variables[key]
		else server.variables[key] = modifs.variables[key]
	}
	if (!modifs.children) return
	for (let childName in modifs.children) {
		let child = modifs.children[childName]
		if (child === null) {
			if (server.children[childName]) delete server.children[childName]
		}
		else {
			if (!server.children[childName]) server.children[childName] = child
			else applyModificationsRec(server.children[childName], child)
		}
	}
}

function setVariable(childName, variableName, newValue) {
	if (!Com.theData) {
		setVariableQueue.push([childName, variableName, newValue])
		return
	}
	let data = null
	if (childName === '') {
		data = {
			name: Com.theData.name,
			variables: {},
			children: {}
		}
		data.variables[variableName] = newValue
	}
	else if (Com.theData.children[childName]) {
		data = {
			name: Com.theData.name,
			variables: {},
			children: {}
		}
		data.children[childName] = {
			name: childName,
			variables: {},
			children: {}
		}
		data.children[childName].variables[variableName] = newValue
	}
	try {
		ws.send(JSON.stringify(data))
	}
	catch(error) {
		console.log('WebSocket send error: '+error)
	}
}

function setGrandVariable(childName, grandChildName, variableName, newValue) {
	if (!Com.theData) {
		setGrandVariableQueue.push([childName, grandChildName, variableName, newValue])
		return
	}
	let data = {
		name: Com.theData.name,
		variables: {},
		children: {}
	}
	data.children[childName] = {
		name: childName,
		variables: {},
		children: {}
	}
	data.children[childName].children[grandChildName] = {
		name: grandChildName,
		variables: {},
		children: {}
	}
	data.children[childName].children[grandChildName].variables[variableName] = newValue
	try {
		ws.send(JSON.stringify(data))
	}
	catch(error) {
		console.log('WebSocket send error: '+error)
	}
}

function connectMagicData(magicData, childName, name, initialize = false) {
	if (!Com.theData) {
		connectMagicDataQueue.push([magicData, childName, name, initialize])
		return
	}
	if (!magicDatas[childName]) magicDatas[childName] = {}
	magicDatas[childName][name] = magicData
	let variables = null
	if (childName === '') variables = Com.theData.variables
	else if (Com.theData.children[childName]) variables = Com.theData.children[childName].variables
	if (variables) {
		if (variables[name] === undefined) {
			if (initialize) setVariable(childName, name, magicData.getValue())
		}
		else magicData.setValue(variables[name])
	}
}

function connectGrandMagicData(magicData, childName, grandChildName, name, initialize = false) {
	if (!Com.theData) {
		connectGrandMagicDataQueue.push([magicData, childName, grandChildName, name, initialize])
		return
	}
	if (!grandMagicDatas[childName]) grandMagicDatas[childName] = {}
	if (grandChildName !== '' && !grandMagicDatas[childName][grandChildName]) grandMagicDatas[childName][grandChildName] = {}
	grandMagicDatas[childName][grandChildName][name] = magicData
	let variables = Com.theData.children[childName].children[grandChildName].variables
	if (variables) {
		if (variables[name] === undefined) {
			if (initialize) setGrandVariable(childName, grandChildName, name, magicData.getValue())
		}
		else magicData.setValue(variables[name])
	}
}

let Com = {
	setVariable: setVariable,
	setGrandVariable: setGrandVariable,
	connectMagicData: connectMagicData,
	connectGrandMagicData: connectGrandMagicData,
	connectedMagicData: MagicData.newMagicData(false),
	newChildArrived: null,
	newGrandChildArrived: null,
	childLeft: null,
	grandChildLeft: null,
	theData: null
}

connect()

export default Com
